export default __webpack_public_path__ + "20caafd89a7930a0501d852cd75c1e1b.glb";